import React, { useState, useEffect } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Popover from '@material-ui/core/Popover';
import { connect } from "react-redux";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Typography from "@material-ui/core/Typography";
import { withTranslation } from "react-i18next";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
  },
  textWrapper: {
    marginLeft: theme.spacing(1),
  },
  iconWrapper: {
    marginRight: theme.spacing(1),
  },
  popover: {
    pointerEvents: 'none',
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
  },
  labelRoot: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: "inherit",
    flexGrow: 1,
    marginBottom: theme.spacing(1),
  },
}))

function DisplayLocation(props) {
  const [taxonomyPath, setTaxonomyPath] = useState({})
  const [title, setTitle] = useState()
  const taxonomyIcon = "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z";
  const topicIcon = "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";
  const knowledgeItemIcon = "M8,12H16V14H8V12M10,20H6V4H13V9H18V12.1L20,10.1V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H10V20M8,18H12.1L13,17.1V16H8V18M20.2,13C20.3,13 20.5,13.1 20.6,13.2L21.9,14.5C22.1,14.7 22.1,15.1 21.9,15.3L20.9,16.3L18.8,14.2L19.8,13.2C19.9,13.1 20,13 20.2,13M20.2,16.9L14.1,23H12V20.9L18.1,14.8L20.2,16.9Z"
  const documentIcon = "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"
  const unknownIcon = taxonomyIcon
  const theme = useTheme();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [defaultSelected, setDefaultSelected] = useState([]);
  const icons = 
    {
      "unknown": unknownIcon,
      "knowledge_item": knowledgeItemIcon,
      "document": documentIcon , 
      "taxonomy_node": taxonomyIcon, 
      "topic": topicIcon,
    }

  useEffect(
    () => {
      setTaxonomyPath(getPathFromProps)
    },
    [props.topicId]
  );

  useEffect(
    () => {
      setTitle(getTitle)
    },
    [props.title]
  );

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const getTitle = () => {
    let title = 
      props.title 
      ? props.title 
      : (props.type === "TAXONOMY_NODE" || props.type === "TOPIC")
        ? getTaxonomyName()
        : props.t(props.type) + " : " + props.itemId
        
    return title
  }

  const getTaxonomyName = () => {
    let name = ""
    let targetType = props.type === "TAXONOMY_NODE" ? "taxonomy" : "topic"
    let lookup = props.taxonomyNodeLookup.map((x) => {
      return Object.assign(
        { 
          id:x.id,
          name:x.name,
          type:x.type,
        })
    });    
    lookup = lookup.filter(t => t.id === props.itemId && t.type === targetType)
    name = lookup.length > 0 ? lookup[0].name : "" 
    return name
  }
  const pruneTree = (node,nodesInPath) => {
    if (node.children) {
      let filtered = node.children.filter(child => {
        return nodesInPath.indexOf(child.id) > 0 || 
                (child.id === props.topicId && child.type === "topic") ||
                (props.type === "TAXONOMY_NODE" && child.id === props.itemId)
      }).map((x) => {
        return Object.assign(
          { 
            id:x.id,
            name:x.name,
            type:x.type,
            children: x.children,
            parentList: x.parentList
          })
      })
      let pruned = []
      filtered.forEach(c => {
        pruned.push(pruneTree(c,nodesInPath))
      })
      node.children = pruned
    }
    return node
  }

  const getPathFromProps = () => {
    let lookup = props.taxonomyNodeLookup.map((x) => {
      return Object.assign(
        { 
          id:x.id,
          name:x.name,
          type:x.type,
          children:x.children,
          parentList: x.parentList
        })
    });

    //build a list of nodes that are parents of the item
    let nodesInPath = []
    lookup.filter(t => (props.type === "TOPIC" || props.type === "TAXONOMY_NODE") ? t.id === props.itemId : t.id === props.topicId).forEach(start => {
      // start.type === "taxonomy" && start.id === props.itemId && nodesInPath.push(start.id)
      start.parentList.forEach((p,index) => {
        nodesInPath.indexOf(p) < 0 && nodesInPath.push(p)
      })
    })
    setDefaultSelected(nodesInPath)

    //take the root node and walk through it pruning children that are not in the path
    let root = Object.assign({},lookup[0])
    let tree = pruneTree(root,nodesInPath)        
     
    return tree
  }

  const renderNode = (node, idx) => {

    let childNodes = node.children 
    ? node.children.filter(
      (ele) => ele.type === "taxonomy" || ele.type === "topic" 
    ) 
    : []

    return (
      <TreeItem
        nodeId={node.id}
        key={idx}
        label={
          <div
            className={classes.labelRoot}
            onClick={(e) => this.onClickNode(e, node)}
          >
            <div className={classes.labelIcon}>
              <svg height="24px" width="24px">
                <path
                  fill={
                    node.type === "taxonomy"
                      ? theme.palette.primary.light
                      : theme.palette.primary.dark
                  }
                  d={
                      node.type === "taxonomy" 
                      ? taxonomyIcon 
                      : node.type === "topic" 
                        ? topicIcon 
                        : knowledgeItemIcon
                    }
                />
              </svg>
            </div>
            <Typography className={classes.labelText}>{node.name ? node.name : ""}</Typography>
          </div>
        }
      >
        {childNodes.map((child, idx) => {
          return renderNode(child, idx);
        })}
      </TreeItem>
    );
  };

  return (
    <>
      {props.onClick
        ?
          <Link color="inherit" component="button" onClick={() => props.onClick()}>
            <div
              className={classes.wrapper}
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            // onClick={props.onClick ? props.onClick : () => {}}
            >
            <div className={classes.iconWrapper}>
              <SvgIcon>
                <path
                  d={icons[props.type ? props.type.toLowerCase() : "unknown"]}
                  fill={props.isTitle ? theme.palette.common.white : theme.palette.primary.light}
                />
              </SvgIcon>
            </div>
            {props.isTitle
              ? <h2>{props.textQualifier ? title + props.textQualifier : title}</h2>
              : <div className={classes.textWrapper}>{props.textQualifier ? title + props.textQualifier : title}</div>
            }
            <ArrowDropDownIcon fontSize="large" />
            </div>
          </Link>
        :
          <div
            className={classes.wrapper}
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          // onClick={props.onClick ? props.onClick : () => {}}
          >
            <div className={classes.iconWrapper}>
              <SvgIcon>
                <path
                  d={icons[props.type ? props.type.toLowerCase() : "unknown"]}
                  fill={props.isTitle ? theme.palette.common.white : theme.palette.primary.light}
                />
              </SvgIcon>
            </div>
            {props.isTitle
              ? <h2>{props.textQualifier ? title + props.textQualifier : title}</h2>
              : <div className={classes.textWrapper}>{props.textQualifier ? title + props.textQualifier : title}</div>
            }
          </div>
      }
          
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <TreeView
          className={classes.root}
          defaultExpanded={defaultSelected}
          defaultCollapseIcon={<ChevronRightIcon />}
          defaultExpandIcon={<ExpandMoreIcon />}
          defaultEndIcon={<div style={{ width: 24 }} />}
          children={renderNode(taxonomyPath)}
          disableSelection={true}
        />
      </Popover>
    </>
  );
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

export default connect(
  mapStateToProps
)(withTranslation()(DisplayLocation));
